<alaris-card>
	@if (tRows.length > 0 || tRows.length === 0 && state.isFiltersApplied) {
		<div class="table-management">
			<div class="left">
				<span class="total"> {{ totalTitle | translate }}: {{ total }} </span>
				<button (click)="editTableFilter()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-filter-vertical"></alaris-icon>
					{{ enableButtons.filters.title | translate }}
					@if (state.isFiltersApplied) {
						<div class="indicator"></div>
					}
				</button>
			</div>
			<div class="right">
				<button (click)="refresh()" alaris-button bType="outline" size="lg">
					<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
					{{ 'actions.refresh_page' | translate }}
				</button>
				<button (click)="edit()" alaris-button bType="primary" size="lg"
						[disabled]="!this.user.allowed(['system_codes.edit'])">
					<alaris-icon class="in-primary" name="icon-plus"></alaris-icon>
					{{ 'system_codes.add' | translate }}
				</button>
			</div>
		</div>
	}
	<div [alarisLoading]="loading$" alarisHorizontalOverflow class="content">
		@if (tRows.length === 0 && !state.isFiltersApplied) {
			<app-empty-table type="system-codes" [disabled]="!this.user.allowed(['system_codes.edit'])" (newSystemCode)="edit()"></app-empty-table>
		} @else {
			<alaris-table (filtersChange)="_applyFilter($event)"
						  (sortingChange)="_applySorting($event)"
						  [filters]="state.filters()"
						  [dblClickRowAction]="dblClickRowAction.bind(this)"
						  [dropDownRowActions]="dropDownRowActions"
						  [rowActions]="rowActions"
						  [tHeaders]="tHeaders()"
						  [tRows]="tRows"
						  [templates]="{ LastUpdated }"
						  alarisOverflowFader>
			</alaris-table>
		}
	</div>
	<div class="footer">
		<alaris-pagination (page)="_pageChange($event)"
						   [activePage]="activePage"
						   [class.without-table-bar]="selection !== null && selection.length === 0"
						   [hidden]="total === 0"
						   [pageSizeOptions]="pageSizeOptions"
						   [pageSize]="pageSize"
						   [total]="total"
						   class="pagination">
		</alaris-pagination>
	</div>
</alaris-card>
<ng-template #LastUpdated let-data="data" [alarisCellCtx]="tRows[0]" let-key="key">
	<span>{{ formatDate(data.LastUpdated) }}</span>
</ng-template>